import { AdminAreaIterations } from "Agile/Scripts/Admin/AreaIterations";
import "VSS/LoaderPlugins/Css!Agile/Admin/AdminHub";
import { ClassificationMode } from "./AreaIterations.DataModels";

import Controls = require("VSS/Controls");
import Navigation = require("VSS/Controls/Navigation");
import Navigation_Services = require("VSS/Navigation/Services");
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import Utils_Core = require("VSS/Utils/Core");
const tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();

interface IProjectWorkControlOptions {
    iterations: IClassificationPayload;
    areas: IClassificationPayload & { areaOwners: any };
    processName: string;
}

interface IClassificationPayload {
    mode: string;
    treeValues: any;
}

class ProjectWorkControl extends Controls.Control<IProjectWorkControlOptions> {
    public static enhancementTypeName: string = "tfs.agile.ProjectWorkControl";

    private _iterationsControl: AdminAreaIterations;
    private _areasControl: AdminAreaIterations;

    public initialize() {
        super.initialize();

        var $element = this.getElement();

        var options = this._options;

        this._iterationsControl = <AdminAreaIterations>Controls.Enhancement.enhance(
            AdminAreaIterations,
            $(".iterations-control", $element),
            options.iterations
                ? {
                      mode: ClassificationMode.MODE_ITERATIONS,
                      data: {
                          iterations: options.iterations.treeValues
                      }
                  }
                : {
                      mode: ClassificationMode.MODE_ITERATIONS
                  }
        );

        this._areasControl = <AdminAreaIterations>Controls.Enhancement.enhance(
            AdminAreaIterations,
            $(".areas-control", $element),
            options.areas
                ? {
                      mode: ClassificationMode.MODE_AREAS,
                      data: {
                          areas: options.areas.treeValues,
                          areaOwners: options.areas.areaOwners
                      }
                  }
                : {
                      mode: ClassificationMode.MODE_AREAS
                  }
        );

        $(".project-admin-work-pivot").on("changed", <any>((sender, view) => {
            switch (view.id) {
                case "areas":
                    this._showAreasControl();
                    break;
                case "iterations":
                default:
                    this._showIterationsControl();
                    break;
            }
        }));

        this._showAreasControl();

        this._attachNavigation();

        this._setupProcessNavUrl();
    }

    private _hideAllControls() {
        this._areasControl.hide();
        this._iterationsControl.hide();
    }

    private _setupProcessNavUrl(): void {
        let url =
            tfsContext.getActionUrl(null, null, {
                area: "settings",
                project: ""
            }) + "/process";

        let processName = Utils_Core.parseJsonIsland($(document), ".project-admin-work .process-name").processName;
        let fragment: string = Navigation_Services.getHistoryService().getFragmentActionLink("workitemtypes", {
            "process-name": processName
        });

        $(".customize-process-link").attr("href", url + fragment);
        $(".customize-process-message").prop("hidden", false);
    }

    private _showAreasControl() {
        this._hideAllControls();
        this._areasControl.show();
    }

    private _showIterationsControl() {
        this._hideAllControls();
        this._iterationsControl.show();
    }

    private _attachNavigation() {
        var $pivotView = $(".project-admin-work-pivot");
        var historySvc = Navigation_Services.getHistoryService();
        var state = historySvc.getCurrentState();
        var pivotControl = <Navigation.PivotView>Controls.Enhancement.getInstance(Navigation.PivotView, $pivotView.eq(0));

        historySvc.attachNavigate(
            "areas",
            (sender, state) => {
                pivotControl.setSelectedView(state.action);
            },
            true
        );

        historySvc.attachNavigate(
            "iterations",
            (sender, state) => {
                pivotControl.setSelectedView(state.action);
            },
            true
        );

        // default selection
        if (!state.action) {
            this._showIterationsControl();
        }
    }
}

Controls.Enhancement.registerEnhancement(ProjectWorkControl, ".project-admin-work");
